/* esm.sh - applesauce-core@5.2.0/operations/delete */
export * from "/*applesauce-core@5.2.0/esnext/operations/delete.mjs";
